// extracted by mini-css-extract-plugin
export default {"preferencesContainer":"styles_preferencesContainer__yYqYp","title":"styles_title__qabbb","content":"styles_content__Cuv5b"};